import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import SockJS from 'sockjs-client';
import { getToken, getTokenPayload } from '../token/token';
import { Client } from '@stomp/stompjs';
import {
    getNotificationCount,
    getNotifications,
    getNotificationTypes,
    prependNotification,
} from '../redux/slices/ecommerce/adminNotifictionSlice';

export default function Websocket() {
    const stompClientRef = useRef(null);
    const [isConnected, setIsConnected] = useState(false);
    const dispatch = useDispatch();
    const tokenPayload = getTokenPayload();
    const token = getToken();
    const userId = tokenPayload?.userId;

    // useEffect(() => {
    //     dispatch(getNotificationTypes());
    //     dispatch(getNotifications());
    //     dispatch(getNotificationCount());
    // }, [dispatch]);

    useEffect(() => {
        if (!userId) {
            return undefined;
        }


        const socket = new SockJS(`${process.env.REACT_APP_BASEURL_VARIABLE_ECOMMERCE}padamiwebsocket`); // backend endpoint
        const stompClient = new Client({
            webSocketFactory: () => socket,
            connectHeaders: {
                Authorization: 'Bearer ' + token
            },
            reconnectDelay: 5000, // auto-reconnect after 5s
            onConnect: () => {
                console.log('Connected to padami WebSocket');
                setIsConnected(true);

                // Subscribe to topic
                stompClient.subscribe("/topic/admin/internal-notifications/" + userId, (notifications) => {
                    const body = JSON.parse(notifications.body);
                    console.log('Notification received:', body);
                    dispatch(prependNotification(body));
                });

                // Send a test message (optional)
                // stompClient.publish({
                //   destination: '/socket/message',
                //   body: 'Hello from React!',
                // });
            },
            onStompError: (frame) => {
                setIsConnected(false);
                console.error('Broker reported error:', frame.headers['message']);
                console.error('Additional details:', frame.body);
            },
        });

        stompClient.activate();
        stompClientRef.current = stompClient;

        return () => {
            setIsConnected(false);
            stompClient.deactivate();
        };
    }, [dispatch, userId]);
    return null;
}
